import React from "react";
import HomePage from "./views/HomePage";
import SideNavContainer from "./SideNavContainer";

class HomePageContainer extends React.Component {
  render() {
    let page = (
      <div>
        <SideNavContainer
          toggleSidebar={this.props.toggleSidebar}
          sidebarActive={this.props.sidebarActive}
        />
        <div className={this.props.sidebarActive ? "main-container" : "main-container expanded"}>
          <iframe src="https://www.vlecad.be" width='100%' height='100%' />
        </div>
      </div>

    );
    return <HomePage page={page} />;
  }
}

export default HomePageContainer;
